import { useParams } from 'react-router-dom'

export const useCoworkerAndTeamleadParams = () => {
  const { coworkerId, teamleadId } = useParams()
  if (!coworkerId) throw new Error('CoworkerId check outside of the coworker profile')
  if (!teamleadId) throw new Error('TeamleadId check outside of the teamlead profile')

  return { coworkerId, teamleadId }
}
